import { authedRequest } from './requests';
import { normalize, schema } from 'normalizr';

// Define schema
const mode= new schema.Entity('modes');

const modesList = [mode];

/**
 *
 * /channels resource requests
 *
 */
export const getModes =
  (token) =>
    authedRequest('v2/modes', token)
      .then(r => normalize(r, modesList).entities);
